import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles/checkout-v-one-style.css";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet";
import SectionOne from "./parts/section-one";
import SectionTwo from "./parts/section-two";
import SectionThree from "./parts/section-three";
import SectionFour from "./parts/section-four";
import SectionFive from "./parts/section-five";
import SectionSix from "./parts/section-six";
import SectionSeven from "./parts/section-seven";
import SectionEight from "./parts/section-eight";
import DemoPopup from "./demopopup"; // 👈 import popup
const CheckoutOne = () => {
  const [navbarVisible, setNavbarVisible] = useState(false);
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isKwikCheckoutCOD = false; // static flag

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const mobileToggle = () => setNavbarVisible(!navbarVisible);
  const mobileSubMenClose = () => setNavbarVisible(false);

  const staticMenuData = [
    { title: "Features", id: "features" },
    { title: "Customer Stories", id: "customer-stories" },
    { title: "FAQs", id: "faq" },
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      mobileSubMenClose(); // optionally close mobile menu after click
    }
  };
  return (
    <div className="" style={{ background: "#fff" }}>
      <Helmet>
        <title>Kwik Engage Checkout 1.0 </title>
        <meta name="description" content="Kwik Engage Checkout 1.0" />

        <meta name="keywords" content="Kwik Engage Checkout 1.0"></meta>
      </Helmet>

      {!isMobile ? (
        <header
          id="header"
          className="header header-Woo d-flex align-items-center "
          style={{
            backgroundColor: "#ffffff",
            fontWeight: "300",
            position: "sticky", // makes it sticky
            top: 0, // stick to top
            zIndex: 999,
          }}
        >
          <div className="container-fluid d-flex align-items-center justify-content-between">
            <Link
              to="/"
              className="logo d-flex align-items-center me-auto me-lg-0"
              style={{ visibility: isKwikCheckoutCOD ? "hidden" : "visible" }}
            >
              <img
                src="/assets/images/kwikwoocomm/logo2.png"
                width="150"
                height="60"
                alt="GoKwik"
              />
            </Link>
            <nav
              id="navbar"
              className={navbarVisible ? "navbar show" : "navbar"}
            >
              <ul>
                {staticMenuData.map((item, index) => (
                  <li key={index} style={{}}>
                    <a
                      onClick={(e) => {
                        e.preventDefault(); // prevent default anchor jump
                        scrollToSection(item.id);
                      }}
                      href={`#${item.id}`}
                      className={
                        location.hash === `#${item.id}` ? "active" : ""
                      }
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>{" "}
            </nav>
              <div>
              <button
                className="cta1-checkout-header flex items-center gap-2"
                onClick={() => setShowPopup(true)}
              >
                Book a Demo
              </button>
              </div>
          
            {navbarVisible ? (
              <i
                onClick={mobileToggle}
                className="mobile-nav-toggle mobile-nav-hide fa-solid fa-xmark"
              ></i>
            ) : (
              <i
                onClick={mobileToggle}
                className="mobile-nav-toggle mobile-nav-show fa-solid fa-bars-staggered"
              ></i>
            )}
          </div>
        </header>
      ) : (
        <header
          id="header"
          className="header header-mob d-flex align-items-center "
          style={{
            backgroundColor: "#ffffff",
            fontWeight: "300",
            top: 0, // stick to top
            zIndex: 999,
            width: "100%",
            position: "fixed", // makes it sticky
          }}
        >
          <div className="container-fluid d-flex align-items-center justify-content-between">
            <Link
              to="/"
              className="logo d-flex align-items-center me-auto me-lg-0"
              style={{ visibility: isKwikCheckoutCOD ? "hidden" : "visible" }}
            >
              <img
                src="/assets/images/kwikwoocomm/logo2.png"
                width="150"
                height="60"
                alt="GoKwik"
                style={{maxWidth:"121px",maxHeight:"35px"}}
              />
            </Link>
            <nav
              id="navbar"
              className={navbarVisible ? "navbar show" : "navbar"}
            >
              <ul>
                {staticMenuData.map((item, index) => (
                  <li key={index} style={{}}>
                    <a
                      onClick={(e) => {
                        e.preventDefault(); // prevent default anchor jump
                        scrollToSection(item.id);
                      }}
                      href={`#${item.id}`}
                      className={
                        location.hash === `#${item.id}` ? "active" : ""
                      }
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>{" "}
            <div>
              <button
                className="cta3-checkout"
                onClick={() => setShowPopup(true)}
              >
                Book a Demo
              </button>
            </div>
            {navbarVisible ? (
              <i
                onClick={mobileToggle}
                className="mobile-nav-toggle mobile-nav-hide fa-solid fa-xmark"
              ></i>
            ) : (
              <i
                onClick={mobileToggle}
                className="mobile-nav-toggle mobile-nav-show fa-solid fa-bars-staggered"
              ></i>
            )}
          </div>
        </header>
      )}

      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />

      <div id="features">
        <SectionFive />
      </div>

      <div id="customer-stories">
        <SectionSix />
      </div>

      <SectionSeven />
      <div id="faq">
        <SectionEight />
      </div>

      {/* 

        <SectionFour />
      </div>
     

     */}

      <DemoPopup show={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
};

export default CheckoutOne;
